import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

import { SharedDataService } from '@teem/services/shared-data.service';
import { LoaderService } from '@teem/services/loader.service';
import { UserService } from '@teem/services/user.service';
import { messages as i18n } from '@teem/constants/messages';

@Component({
  selector: 'bank-info-tab',
  templateUrl: './bank-info.component.html',
  styleUrls: ['./bank-info.component.scss']
})
export class BankInfoComponent implements OnInit {
  @Output() public updateUserDetails = new EventEmitter();
  bankDetailsForm: any = {};
  bankDetailsFormGroup: FormGroup;
  formSubmit: boolean = false;
  userDetails: any = {};
  @Input('userDetails')
  set getInfo(val: any) {
    this.bankDetailsForm = Object.assign({}, val);
    this.initBankDetailsForm();
  }

  constructor(

    private loaderService: LoaderService,
    private userService: UserService,
    private sharedDataService: SharedDataService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {

    this.initBankDetailsForm();
  }

  initBankDetailsForm() {
    this.bankDetailsFormGroup = this.fb.group({
      account_number: [this.bankDetailsForm?.setting.payment_info.account_number, Validators.required],
      user_name: [this.bankDetailsForm?.setting.payment_info.name, Validators.required],
      payment_country: [this.bankDetailsForm?.setting.payment_info.country, Validators.required],
      bank_name: [this.bankDetailsForm?.setting.payment_info.bank_name, Validators.required],
      iban: [this.bankDetailsForm?.setting.payment_info.iban, Validators.required]
    });
  }


  onSubmit() {
    this.formSubmit = true;
    if (this.bankDetailsFormGroup.valid) {
      let fd = this.bankDetailsFormGroup.value;
      this.loaderService.startLoading();
      this.userService.updateBusinessInfo(fd).subscribe(
        (res: any) => {
          this.loaderService.stopLoading();
          this.formSubmit = false;
          Object.assign((window as any).userInfo, res.data);

          this.userDetails.accept_bank_transfer = res.data.accept_bank_transfer;
          this.userDetails.setting = res.data.setting;
          this.updateUserDetails.emit(this.userDetails);

          // let fd = this.accountSettingForm.value;
          let user = this.sharedDataService.getItem('userInfo');
          user.accept_bank_transfer = res.data.accept_bank_transfer;
          user.setting = res.data.setting;
          this.sharedDataService.setItem('userInfo', user);
          //  Also need to update user avatar here
          Swal.fire(i18n.done, i18n.setting.business_information_updated, 'success');
        },
        (err) => {
          this.loaderService.stopLoading();
          // Set server side error
          if (err.status === 422) {
            if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
              let validationErrors = err.error.errors;
              Object.keys(validationErrors).forEach((prop) => {
                this.bankDetailsFormGroup.controls[prop]?.setErrors({
                  serverError: validationErrors[prop]
                })
              })
            }
          }

          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        }
      );
    }
  }
}
